import styled from 'styled-components';
import black_arrow from 'assets/img/icons/black_arrow.png'

export const RedirectWrapper = styled.div`
	display: none;
  	z-index: 2;
	flex-direction: row;
  	justify-content: flex-end;
	position: fixed;
  	left: 0;
  	bottom: 0;
  	width: 100vw;
	padding: 16px 32px;
  	box-sizing: border-box;
  	background: linear-gradient(180deg, rgba(1, 1, 1, 0.00) 0%, #000 100%);
  
  	@media(max-width: 1169px) {
		display: flex;  
	}
`

export const RedirectButton = styled.img.attrs(p => ({ ...p, src: black_arrow }))`
	width: 69px;
  	height: 69px;
`
